// @ts-nocheck
import React, { useState } from 'react';
import { ScrollView, View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import DateTimeInput from '../../../components/DateTimeInput';
import Navbar from '../../../components/Navbar';
import SubmitButton from '../../../components/SubmitButton';
import dataFrameInitialState from '../utils';
import { createDateFrame } from '../../../api/dataframe';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../service/flashMessage';
import Icon from '@expo/vector-icons/Feather';
import Input from '../../../components/Input';
import VStack from '../../../components/VStack';
import TextArea from '../../../components/TextArea';
import Checkbox from '../../../components/Checkbox';
import Select from '../../../components/Select';

const CreateDateFrame = ({ navigation, route }) => {
  const unitId = route.params?.unitId;
  const [dateFrameState, setDateFrameState] = useState({
    ...dataFrameInitialState,
    unitId,
  });
  const [numberOfDays, setNumberOfDays] = useState(1);

  const handleStartDateConfirm = date => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + parseInt(numberOfDays, 10));

    setDateFrameState({ ...dateFrameState, startDate: date, endDate: newDate });
  };

  const handleEndDateConfirm = date => {
    const diffTime = new Date(date) - new Date(dateFrameState.startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setNumberOfDays(diffDays);
    setDateFrameState({ ...dateFrameState, endDate: date });
  };

  const collectUserInput = async () => {
    let dateFrame = dateFrameState;
    if (!dateFrameState.shortDescription) {
      dateFrame.shortDescription = `${new Date(
        dateFrame.startDate,
      ).toDateString()}- ${new Date(dateFrame.endDate).toDateString()}`;
    }
    try {
      await createDateFrame(dateFrame);
      showSuccessMessage('Date frame created');
      navigation.goBack();
    } catch (error) {
      showErrorMessage('CreateDateFrame: ' + error.message);
    }
  };

  return (
    <View style={styles.container}>
      <Navbar navigation={navigation} title="Create date frame" />
      <ScrollView
        style={styles.scrollView}
        showsVerticalScrollIndicator={false}>
        <>
          <>
            <Text style={styles.textInputLabel}>Short description</Text>
            <Input
              placeholder="Enter short description"
              value={dateFrameState.shortDescription}
              onChangeText={text =>
                setDateFrameState({ ...dateFrameState, shortDescription: text })
              }
            />
            <Text style={styles.label}>Date frame type</Text>
            <Select
              placeholder="Select dateframe type"
              minWidth={300}
              selectedValue={dateFrameState.type}
              onValueChange={val =>
                setDateFrameState({ ...dateFrameState, type: val })
              }>
              <Select.Item label="Reservation" value="Reservation" />
              <Select.Item label="Lease" value="Lease" />
              <Select.Item label="Visitor" value="Visitor" />
            </Select>
          </>
          <DateTimeInput
            label="From"
            value={new Date(dateFrameState.startDate)}
            onConfirm={date => {
              handleStartDateConfirm(date);
            }}
            mode='date'
          />
          <VStack>
            <Text style={styles.textInputLabel}>Days</Text>
            <Input
              placeholder="Enter number of days"
              value={numberOfDays.toString()}
              keyboardType="number-pad"
              onChangeText={text => {
                setNumberOfDays(parseInt(text === '' ? 0 : text, 10));
                const date = new Date(dateFrameState.startDate);
                date.setDate(
                  date.getDate() + parseInt(text === '' ? 0 : text, 10),
                );
                setDateFrameState({ ...dateFrameState, endDate: date });
              }}
              minWidth={200}
              InputRightElement={
                <TouchableOpacity
                  style={styles.iconButton}
                  onPress={() => {
                    let newDays = numberOfDays + 1;
                    setNumberOfDays(newDays);
                    const date = new Date(dateFrameState.startDate);
                    date.setDate(date.getDate() + newDays - 1);
                    setDateFrameState({ ...dateFrameState, endDate: date });
                  }}>
                  <Icon name="plus" size={24} color="#007bff" />
                </TouchableOpacity>
              }
              InputLeftElement={
                <TouchableOpacity
                  disabled={numberOfDays === 1}
                  style={styles.iconButton}
                  onPress={() => {
                    let newDays = numberOfDays - 1 >= 1 ? numberOfDays - 1 : 1;
                    setNumberOfDays(newDays);
                    const date = new Date(dateFrameState.startDate);
                    date.setDate(date.getDate() + newDays - 1);
                    setDateFrameState({ ...dateFrameState, endDate: date });
                  }}>
                  <Icon name="minus" size={24} color="#007bff" />
                </TouchableOpacity>
              }
            />
          </VStack>
          <DateTimeInput
            label="To"
            value={new Date(dateFrameState.endDate)}
            onConfirm={date => {
              handleEndDateConfirm(date);
            }}
            mode='date'
          />
          <View style={styles.checkboxContainer}>
            <Text style={styles.checkBoxLabel}>Allow overlap ?</Text>
            <Checkbox
              disabled={false}
              tintColors={{
                true: '#007bff',
                false: '#A0AEC0',
              }}
              value={dateFrameState.overlapAllowed}
              onChange={value =>
                setDateFrameState({
                  ...dateFrameState,
                  overlapAllowed: value,
                })
              }
              aria-label="Allowed to overlap"
              style={styles.checkbox}
            />
          </View>
          <>
            <Text style={styles.textInputLabel}>Notes</Text>
            <TextArea
              placeholder="Enter notes"
              value={dateFrameState.notes}
              style={styles.multiLinetextInput}
              multiline
              onChangeText={text =>
                setDateFrameState({ ...dateFrameState, notes: text })
              }
            />
          </>
        </>
      </ScrollView>
      <SubmitButton onPress={collectUserInput} title={'Save'} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollView: {
    paddingHorizontal: 8,
    paddingVertical: 16,
  },
  label: {
    marginTop: 16,
    marginBottom: 8,
    flex: 1,
  },
  textInputLabel: {
    marginTop: 8,
  },
  iconButton: {
    paddingHorizontal: 16,
  },
  checkboxContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 4,
    paddingBottom: 12,
  },
  checkBoxLabel: {
    marginTop: 4,
  },
  checkbox: {
    marginTop: 4,
  },
  multiLinetextInput: {
    minHeight: 100,
  },
});

export default CreateDateFrame;
